"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRequestor;

function getRequestor() {
  return 'browser';
}

module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9yZXF1ZXN0b3ItYnJvd3Nlci50cyJdLCJuYW1lcyI6WyJnZXRSZXF1ZXN0b3IiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBZSxTQUFTQSxZQUFULEdBQWdDO0FBQzNDLFNBQU8sU0FBUDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gZ2V0UmVxdWVzdG9yKCk6IHN0cmluZyB7ICAgIFxuICAgIHJldHVybiAnYnJvd3Nlcic7XG4gIH0iXX0=